import type { RouteRecordRaw } from 'vue-router';

import CancelExecutionView from '@/flow/execution/views/CancelExecutionView.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/uitschrijven/:executionId/:contactId',
        name: 'cancel-execution',
        props: true,
        components: {
            default: CancelExecutionView,
        },
        meta: {
            anonymous: true,
        },
    },
];

export default routes;
